import { Controller } from 'stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: 'room_ids' },
    item: { type: String, default: 'room-id' },
    handle: { type: String, default: '.rb-room-card__drag' },
    draggable: { type: String, default: '.rb-room-card' },
    label: { type: String, default: 'order-label' },
    direction: String,
  };

  connect() {
    if (!this.hasUrlValue) return;

    const options = {
      animation: 180,
      handle: this.handleValue,
      draggable: this.draggableValue,
      dataIdAttr: `data-${this.itemValue}`,
      ghostClass: 'is-dragging',
      chosenClass: 'is-chosen',
      forceFallback: true,
      fallbackOnBody: true,
      fallbackTolerance: 4,
      swapThreshold: 0.35,
      emptyInsertThreshold: 12,
      onEnd: (event) => this.handleEnd(event),
    };

    if (this.hasDirectionValue) options.direction = this.directionValue;

    this.sortable = Sortable.create(this.element, options);
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy();
  }

  handleEnd(event) {
    this.clearDragState(event.item);
    if (event.oldIndex === event.newIndex) return;

    this.persist();
  }

  persist() {
    const ids = this.sortable.toArray().filter(Boolean);
    if (!ids.length) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = new URLSearchParams();
    ids.forEach((id) => body.append(`${this.paramValue}[]`, id));

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    })
      .then((response) => {
        if (!response.ok) {
          window.location.reload();
          return;
        }

        this.updateOrderLabels();
      })
      .catch(() => {
        window.location.reload();
      });
  }

  updateOrderLabels() {
    this.element
      .querySelectorAll(`[data-${this.labelValue}]`)
      .forEach((label, index) => {
        label.textContent = `Order ${index + 1}`;
      });
  }

  clearDragState(item) {
    [item, ...this.element.querySelectorAll('.is-dragging, .is-chosen')].forEach(
      (el) => {
        if (el) el.classList.remove('is-dragging', 'is-chosen');
      }
    );
  }
}
